module.exports = __webpack_public_path__ + "static/novakova-2e5e022059aa91566283fe1ebcc595ff.jpg";